import { useCallback } from 'react';
import { useResourceContext, useStore } from 'react-admin';
export var useDatagridAGGridController = function (props) {
    var onStateUpdatedProp = props.onStateUpdated, onGridPreDestroyedProp = props.onGridPreDestroyed, preferenceKey = props.preferenceKey;
    var resource = useResourceContext();
    var finalPreferenceKey = preferenceKey || "".concat(resource, ".ag-grid.params");
    var _a = useStore("".concat(finalPreferenceKey, ".grid"), {}), storedGridState = _a[0], setStoredGridState = _a[1];
    var storeDisabled = preferenceKey === false;
    var onStateUpdated = useCallback(function (params) {
        onStateUpdatedProp && onStateUpdatedProp(params);
        if (storeDisabled)
            return;
        setStoredGridState(params.state);
    }, [onStateUpdatedProp, setStoredGridState, storeDisabled]);
    var onGridPreDestroyed = useCallback(function (params) {
        onGridPreDestroyedProp && onGridPreDestroyedProp(params);
        if (storeDisabled)
            return;
        setStoredGridState(params.state);
    }, [onGridPreDestroyedProp, setStoredGridState, storeDisabled]);
    return {
        onStateUpdated: onStateUpdated,
        onGridPreDestroyed: onGridPreDestroyed,
        initialState: storedGridState,
        preferenceKey: preferenceKey,
    };
};
